import "./auth-token";
import "./public-path";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import zhCN from 'antd/es/locale/zh_CN';
import { registerMicroApps, start, setDefaultMountApp } from "qiankun";

import Main from "./components/Main";
import { getMicroApps, getSubAppUrl, notifySubAppMounted } from "@/config/microApp";
import { ANT_PREFIX } from "@/config";

// import "@/utils/rem";
// import 'kaihong-design/es/Style/steps.less';
import "@/assets/style/index.less";
// iconfont-Symbol模式需要
import "@/assets/fonts/iconfontColor/iconfont";

// redux
import store from "./stores";
import { init } from "@/utils/beaconOtlp";

// router
// import { rootRoutes, renderRoutes } from "@/routes";

import { publicPath } from "./utils/base";
import { withTenantParam } from "./utils/globalTenant";

/**
 * antd 4 的静态方法（Modal.confirm / message / notification）不消费 React 树上的 ConfigProvider，
 * 它们读的是模块级的 globalConfig，默认前缀是 ant。
 *
 * 基座的 less 用 @ant-prefix: khAnt 编译，产物里只有 .khAnt-modal-* 而没有 .ant-modal-*，
 * 不设置这一行，所有静态弹窗/提示都会以裸 DOM 形式插到 body 末尾（无定位、无遮罩），
 * 一打开还会把页面滚动到底部，看起来就像整页样式崩了。
 */
ConfigProvider.config({ prefixCls: ANT_PREFIX });

console.log("getMicroApps()", getMicroApps());

init();

registerMicroApps(getMicroApps(), {
  beforeLoad: () => {
    console.log("qian kun beforeLoad", +new Date());
    return Promise.resolve();
  },
  afterMount: (app: any) => {
    notifySubAppMounted(app?.name);
    console.log("qian kun afterMount", +new Date());
    return Promise.resolve();
  },
});

export const initRender = (initUrl: string = "/kh_overview/device-count") => {
  start({
    sandbox: {
      // 启用样式隔离
      experimentalStyleIsolation: true,
    },
  });

  if (window.location.pathname === publicPath && window.location.hash === "") {
    // 默认拉起超级设备管理平台子应用
    if (localStorage.getItem("INIT_SYSTEM") === "1") {
      // 全局租户模式（tenant=all）下默认拉起时同样带上租户参数
      setDefaultMountApp(withTenantParam("/#/khlinks/"));
    } else {
      const subAppUrl = getSubAppUrl(initUrl);
      if (subAppUrl) {
        setDefaultMountApp(subAppUrl.startsWith("/") ? subAppUrl : "/" + subAppUrl);
      }
    }
  }
};

const root = ReactDOM.createRoot(document.getElementById("main-root") as HTMLElement);

root.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN} prefixCls={ANT_PREFIX}>
      {/* <App style={{height: '100%'}}> */}
      <Suspense>
        <BrowserRouter>
          <Main />
        </BrowserRouter>
      </Suspense>
      {/* </App> */}
    </ConfigProvider>
  </Provider>
);
